module.exports = __webpack_public_path__ + "static/img/pdk-03.81198c6e.jpg";